module.exports = __webpack_public_path__ + "static/media/consulenzasaperedipiu.fd316c3c.png";